// @ai-generated 2026-09-04T08:07:37+00:00 by dimitri.driediger@synqony.com using Claude Opus 5
import { type ApiLocationSnapshot } from '@Model';
import {
    Button,
    FloatingCard,
    iconSizeMd,
    iconSizeSm,
    IconTextRow,
    useTranslate,
} from '@synqo/frontend-component-library';
import { IconMapPin, IconUser } from '@tabler/icons-react';
import classes from './ContainerSteps.module.css';
import { hasSiteContact, siteContactDetail, siteContactName } from './Site/siteContact';

interface SiteCardProps {
    site: ApiLocationSnapshot;
    /** Leads back to the site step. */
    onChange: () => void;
}

/**
 * The chosen site, as every step after the first one recalls it: label, address, on-site contact
 * and a way back to change it.
 */
export function SiteCard({ site, onChange }: SiteCardProps) {
    const i18n = useTranslate('');

    return (
        <FloatingCard
            title={i18n('Leistungsort')}
            separateHeader={false}
            collapsible={false}
            additionalHeaderItems={
                <Button
                    appearance="transparent"
                    size="xs"
                    className={classes.changeLink}
                    onClick={onChange}
                    label={i18n('Ändern')}
                >
                    {i18n('Ändern')}
                </Button>
            }
        >
            <IconTextRow
                icon={<IconMapPin size={iconSizeMd} />}
                title={site.address.label || site.address.display_string}
                subtitle={site.address.display_string}
            />
            {hasSiteContact(site.contact) && (
                <IconTextRow
                    icon={<IconUser size={iconSizeSm} />}
                    iconVariant="plain"
                    divider
                    prefix={i18n('Ansprechpartner vor Ort:')}
                    title={[siteContactName(site.contact), siteContactDetail(site.contact)].filter(Boolean).join(' · ')}
                />
            )}
        </FloatingCard>
    );
}
